import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

/**
 * Icon-only back-navigation button for full-screen pages, placed at the
 * left of the title row. Navigates via browser history (matches the
 * back button users expect from `Location.back()`).
 */
@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [ButtonComponent, IconComponent],
  templateUrl: './back-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-button.component.css',
})
export class BackButtonComponent {
  private location = inject(Location);

  @Input() ariaLabel = 'Back';

  goBack(): void {
    this.location.back();
  }
}
